import { render, staticRenderFns } from "./inputDialog.vue?vue&type=template&id=048fa2f0&scoped=true&"
import script from "./inputDialog.vue?vue&type=script&lang=js&"
export * from "./inputDialog.vue?vue&type=script&lang=js&"
import style0 from "./inputDialog.vue?vue&type=style&index=0&id=048fa2f0&lang=less&scoped=true&"
import style1 from "./inputDialog.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048fa2f0",
  null
  
)

export default component.exports